import { useState, useEffect } from "react";

import { Box, Grid, Typography } from "@material-ui/core";

import { ActionTimeGroup } from "../../../../components/actionTimeTimeGroup";
import { SAHeaderBox } from "../../../powerRevenues/tabs/detailedSensitivityAnalysis/SAHeaderBox";
import NpvPowerRevenue from "./NpvPowerRevenue";
import NoiIncrease from "./NoiIncrease";
import RoiIncrease from "./RoiIncrease";
import BuildIncrease from "./BuildIncrease";

import useDebounce from "./../../../../hooks/useDebounce";

import { noiEndPoints } from "../../../../services/apiEndPoints";
import { api, getData } from "../../../../services/api";
import { isFloatOrInteger } from "../../../../services/utils";
const initialData = {
  sold: "0%",
  purchased: "0%",
  praas: "0%",
  gas: "0/XXX",
};

const DEFAULT_VALUE = {
  discount_rate: 0,
  existing_noi: 0,
  existing_roi: 0,
  cap_rate: 0,
};

const MILLION = 1000000;

export const OverviewTab = () => {
  const [filterValues, setFilterValues] = useState(DEFAULT_VALUE);
  const [filterInput, setFilterInput] = useState(DEFAULT_VALUE);
  const [assumptionsData, setAssumptionsData] = useState(initialData);
  const [isParameterChanges, setIsParameterChanged] = useState({
    isChanged: false,
    type: "",
  });
  const debounce = useDebounce(filterInput);

  useEffect(() => {
    getData(noiEndPoints.ASSUMPTIONS, setAssumptionsValues);
    getData(noiEndPoints.GET_PARAMETERS, saveFilters);
  }, []);

  useEffect(() => {
    if (isParameterChanges.isChanged) {
      const { existing_noi, existing_roi, discount_rate, cap_rate } =
        filterInput;
      if (existing_noi && existing_roi && discount_rate && cap_rate) {
        api
          .post(noiEndPoints.ADD_PARAMETERS, {
            ...filterInput,
            existing_noi: filterInput.existing_noi * MILLION,
          })
          .then((res) => {
            if (res.status === 201) {
              getData(noiEndPoints.GET_PARAMETERS, (value) => {
                setFilterValues({
                  ...value,
                  existing_noi: value.existing_noi / MILLION,
                });
              });
            }
          });
      }
      setIsParameterChanged({ isChanged: false, type: "" });
    }
  }, [debounce]);

  const saveFilters = (value) => {
    setFilterValues({ ...value, existing_noi: value.existing_noi / MILLION });
    setFilterInput({ ...value, existing_noi: value.existing_noi / MILLION });
  };

  const setAssumptionsValues = (values) => {
    const {
      sold_electricity_margin: sold,
      purshased_electricity_margin: purchased,
      digitalization_impact: praas,
      gas_prices: gas,
    } = values;
    const data = {
      sold: `${sold} %`,
      purchased: `${purchased} %`,
      praas: `${praas} %`,
      gas: `${gas} / XXX`,
    };
    setAssumptionsData(data);
  };

  const handleChangeFloatInteger = (type, value) => {
    setFilterInput((prevState) => {
      return {
        ...prevState,
      [type]: value,
    };
  });
    if (isFloatOrInteger(value))     {
      setIsParameterChanged({
        isChanged: true,
        type,
      });
    }
  };

  const handleChange = (type, value) => {
    setFilterInput((prevState) => {
      return {
        ...prevState,
        [type]: !isNaN(value) ? +value : 0,
      };
    });

    setIsParameterChanged({
      isChanged: true,
      type,
    });
  };

  return (
    <Box>
      <ActionTimeGroup
        TimeRangeComponent={() => (
          <Typography style={{ fontWeight: 700 }}>PRaaS parameters:</Typography>
        )}
        containerStyle={{
          marginBottom: 5,
        }}
      />
      <SAHeaderBox
        formData={assumptionsData}
        handleChange={() => null}
        editable={false}
      />
      <Grid container spacing={3}>
        <NpvPowerRevenue
          value={filterInput.discount_rate}
          filtervalue={filterValues.discount_rate}
          handleChange={handleChange}
        />
        <NoiIncrease
          value={filterInput.existing_noi}
          filtervalue={filterValues.existing_noi}
          handleChange={handleChangeFloatInteger}
        />
        <RoiIncrease
          value={filterInput.existing_roi}
          filtervalue={filterValues.existing_roi}
          handleChange={handleChange}
        />
        <BuildIncrease
          value={filterInput.cap_rate}
          filtervalue={filterValues.cap_rate}
          handleChange={handleChange}
          existingNoi={filterValues.existing_roi}
        />
      </Grid>
    </Box>
  );
};
